export default "__VITE_ASSET__egbtpbg1__"